import watchUtils = require("esri/core/watchUtils");
import FeatureLayer = require("esri/layers/FeatureLayer");
import GroupLayer from "esri/layers/GroupLayer";
import { SimpleRenderer } from "esri/renderers";
import { SimpleLineSymbol } from "esri/symbols";
import * as layerSource from "./layerSource";
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import BuildPopups from "./buildPopups";

export const drawLayer = new GraphicsLayer({
  title: "draw",
  listMode: "hide",
  id: "drawLayer"
});

export const iRoadsRenderer = new SimpleRenderer({
  symbol: new SimpleLineSymbol({
    width: "7px",
    color: [255,255,255,0.01],
  })
});

export const idotRoadsLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.IDOTRoadsLayer,
  renderer: iRoadsRenderer,
  visible: true,
  opacity: 1,
  // outFields: ["*"],
  title: "IDOT Roads"
});

export const StateKRLayerWith = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.StateKRLayerWith,
  renderer: new SimpleRenderer({
    symbol: new SimpleLineSymbol({
      width: "2px",
      color: [255,0,0,0.5],
    })
  }),
  visible: false,
  opacity: 0,
  // outFields: ["*"],
  title: "IDOT State KR"
});

export const StateKRLayerAgainst = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.StateKRLayerAgainst,
  renderer: new SimpleRenderer({
    symbol: new SimpleLineSymbol({
      width: "2px",
      color: [255,0,0,0.5],
    })
  }),
  visible: false,
  opacity: 0,
  // outFields: ["*"],
  title: "IDOT State KR"
});


watchUtils.whenTrueOnce(idotRoadsLayer, "loaded", () => {
  BuildPopups.buildPopupIfLoaded(idotRoadsLayer);
});

export const baseGroupLayer = new GroupLayer({
  title: "Base Layers",
  id: "00 - Base Layers",
  visible: true,
  listMode: "hide", // don't show in layer list
  visibilityMode: "independent",
  layers: [idotRoadsLayer]
});
